import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function SocialButtons({ testIdPrefix = "" }) {
  const [providers, setProviders] = useState({ google_emergent: true, linkedin: false, microsoft: false });

  useEffect(() => { api.get("/auth/providers").then(r => setProviders(r.data)).catch(() => {}); }, []);

  const googleAuth = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const oauthAuth = async (provider) => {
    if (!providers[provider]) { toast.error(`${provider} not configured. Set the client id and secret in backend/.env.`); return; }
    try {
      const redirectUri = `${window.location.origin}/auth/callback?provider=${encodeURIComponent(provider)}`;
      const { data } = await api.get(`/auth/${provider}/url`, { params: { redirect_uri: redirectUri } });
      sessionStorage.setItem("oauth_provider", provider);
      window.location.href = data.url;
    } catch (e) { toast.error(e.response?.data?.detail || "OAuth failed"); }
  };

  return (
    <>
      <div className="relative flex items-center gap-4 py-2">
        <div className="flex-1 h-px bg-border"/>
        <div className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">or</div>
        <div className="flex-1 h-px bg-border"/>
      </div>

      <button
        type="button"
        data-testid={`${testIdPrefix}google`}
        onClick={googleAuth}
        className="inline-flex items-center justify-center rounded-md border border-border bg-background hover:bg-accent text-foreground transition-colors w-full py-3 flex items-center justify-center gap-3"
      >
        <svg width="16" height="16" viewBox="0 0 24 24"><path fill="#EA4335" d="M12 5c1.6 0 3 .5 4.1 1.5l3.1-3.1C17.2 1.6 14.8.5 12 .5 7.4.5 3.4 3 1.4 6.9L5 9.7C6 7 8.8 5 12 5z"/><path fill="#34A853" d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.5h6.5c-.3 1.5-1.1 2.8-2.4 3.7l3.5 2.7c2.1-1.9 3.9-4.9 3.9-8.6z"/><path fill="#FBBC05" d="M5 14.3c-.3-.8-.5-1.6-.5-2.5s.2-1.7.5-2.5L1.4 6.5C.5 8.2 0 10.1 0 12s.5 3.8 1.4 5.5L5 14.3z"/><path fill="#4285F4" d="M12 23.5c3.2 0 5.9-1 7.9-2.8l-3.5-2.7c-1 .7-2.3 1.1-4.4 1.1-3.2 0-6-2-7-4.7L1.4 17c2 3.9 6 6.5 10.6 6.5z"/></svg>
        Continue with Google
      </button>

      <div className="grid grid-cols-2 gap-2">
        <button
          type="button"
          data-testid={`${testIdPrefix}linkedin`}
          onClick={()=>oauthAuth("linkedin")}
          disabled={!providers.linkedin}
          title={providers.linkedin ? "Sign in with LinkedIn" : "LinkedIn OAuth not configured"}
          className="inline-flex items-center justify-center rounded-md border border-border bg-background hover:bg-accent text-foreground transition-colors py-3 flex items-center justify-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#0A66C2"><path d="M20.5 2h-17A1.5 1.5 0 0 0 2 3.5v17A1.5 1.5 0 0 0 3.5 22h17a1.5 1.5 0 0 0 1.5-1.5v-17A1.5 1.5 0 0 0 20.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 1 1 8.3 6.5a1.78 1.78 0 0 1-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0 0 13 14.19a.66.66 0 0 0 0 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 0 1 2.7-1.4c1.55 0 3.36.86 3.36 3.66z"/></svg>
          LinkedIn
        </button>
        <button
          type="button"
          data-testid={`${testIdPrefix}microsoft`}
          onClick={()=>oauthAuth("microsoft")}
          disabled={!providers.microsoft}
          title={providers.microsoft ? "Sign in with Microsoft" : "Microsoft OAuth not configured"}
          className="inline-flex items-center justify-center rounded-md border border-border bg-background hover:bg-accent text-foreground transition-colors py-3 flex items-center justify-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <svg width="14" height="14" viewBox="0 0 24 24"><path fill="#F25022" d="M2 2h10v10H2z"/><path fill="#7FBA00" d="M12 2h10v10H12z"/><path fill="#00A4EF" d="M2 12h10v10H2z"/><path fill="#FFB900" d="M12 12h10v10H12z"/></svg>
          Microsoft
        </button>
      </div>
    </>
  );
}
